import { createContext, useContext, useState } from 'react';
import { Associate } from '../types/associates';

// datatype for the context declared here
interface IAssociateContext {
  associate: Associate | null;
  showDetailsModal: boolean;
  setAssociate: React.Dispatch<React.SetStateAction<Associate | null>>;
  setShowDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const AssociateContext = createContext<IAssociateContext | null>(null);

const AssociateProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [associate, setAssociate] = useState<Associate | null>(null);
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);

  // rendering the context provider here
  return (
    <AssociateContext.Provider
      value={{ associate, showDetailsModal, setAssociate, setShowDetailsModal }}
    >
      {children}
    </AssociateContext.Provider>
  );
};

export default AssociateProvider;

// custom hook to access associate context declared here
export const useAssociateContext = () => {
  const context = useContext(AssociateContext);

  if (!context) {
    throw new Error('useAssociateContext must be within AssociateProvider!');
  }

  return context;
};
